export const PLAYTIME_OPTIONS = [
    { value: 0, label: "Any" },
    { value: 100, label: "100" },
    { value: 250, label: "250" },
    { value: 500, label: "500" },
    { value: 750, label: "750" },
    { value: 1000, label: "1000" },
    { value: 1500, label: "1500+" },
];

export const MATCH_COUNT_OPTIONS = [
    { value: 0, label: "Any" },
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: 250, label: "250" },
    { value: 500, label: "500" },
];

export const ELO_GAP_OPTIONS = [
    { value: 100, label: "100" },
    { value: 150, label: "150" },
    { value: 250, label: "250" },
    { value: 500, label: "500" },
    { value: 750, label: "750" },
    { value: 1000, label: "1000" },
    { value: 0, label: "No limit" },
];

export const AGE_OPTIONS = [
    { value: 0, label: "Any" },
    { value: 14, label: "14+" },
    { value: 16, label: "16+" },
    { value: 18, label: "18+" },
    { value: 21, label: "21+" },
];

export function snapFigure(value, options, fallback) {
    if (!Array.isArray(options) || options.length === 0) {
        return fallback;
    }

    const numeric = Number(value);
    if (!Number.isFinite(numeric)) {
        return fallback;
    }

    const exact = options.find((option) => option.value === numeric);
    if (exact) {
        return exact.value;
    }

    let nearest = options[0].value;
    let nearestDiff = Infinity;
    options.forEach((option) => {
        const diff = Math.abs(option.value - numeric);
        if (diff < nearestDiff) {
            nearest = option.value;
            nearestDiff = diff;
        }
    });
    return nearest;
}

export function resolveSegmentFigure(options, setting) {
    if (!Object.prototype.hasOwnProperty.call(options, setting.name)) {
        return setting.figure;
    }

    if (!options[setting.name]) {
        return 0;
    }

    return snapFigure(
        options[`${setting.name}_figure`],
        setting.options,
        setting.figure,
    );
}
